import { HttpContextToken } from '@angular/common/http';

export const GLOBAL_TOAST_KEY = 'GLOBAL_TOAST_KEY';
export const GLOBAL_CONFIRMATION_KEY = 'GLOBAL_CONFIRMATION_KEY';

export const API_CONTEXT_TOKEN = new HttpContextToken(() => '');
